import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { BASE_URL } from '../../api/baseURL';
import { axiosBaseQuery } from '../axiosBaseQuery';
import { PaginatedResponse, Response } from '../genericInterface';
import { IAdmin } from './interface';

export const adminApi = createApi({
  reducerPath: 'adminApi',
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL
  }),
  endpoints: (builder) => ({
    addAdmin: builder.mutation<Response<IAdmin>, FormData>({
      query: (payload) => ({
        url: '/admin/add',
        method: 'POST',
        body: payload
      })
    }),
    deleteAdmin: builder.mutation<Response<IAdmin>, string>({
      query: (payload) => ({
        url: `/admin/delete-admin/${payload}`,
        method: 'DELETE'
      })
    }),
    fetchAdmin: builder.query<PaginatedResponse<IAdmin>, string | void>({
      query: (queryParams) => ({
        url: '/admin/fetch-many',
        method: 'GET'
      })
    })
  })
});

export const {
  useAddAdminMutation,
  useDeleteAdminMutation,
  useFetchAdminQuery
} = adminApi;
